/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Nocredential2Inputs */

const id_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada kredensial yang diterima dari Google`)
};

const ms_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada kelayakan diterima daripada Google`)
};

const da_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen legitimationsoplysninger modtaget fra Google`)
};

const de_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Anmeldedaten von Google erhalten`)
};

const en_us2_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credential received from Google`)
};

const es_es2_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se recibió credencial de Google`)
};

const es_mx2_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se recibió credencial de Google`)
};

const fil_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang natanggap na credential mula sa Google`)
};

const fr_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune information d'identification reçue de Google`)
};

const it_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna credenziale ricevuta da Google`)
};

const hu_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem érkezett hitelesítő adat a Google-től`)
};

const nl_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen referentie ontvangen van Google`)
};

const no_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen legitimasjon mottatt fra Google`)
};

const pl_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie otrzymano poświadczenia od Google`)
};

const pt_br2_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credential received from Google`)
};

const pt_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma credencial recebida do Google`)
};

const ro_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-a primit nicio acreditare de la Google`)
};

const fi_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Googlelta ei saatu tunnistetietoja`)
};

const sv_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen credential mottagen från Google`)
};

const vi_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không nhận được thông tin xác thực từ Google`)
};

const tr_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google'dan kimlik bilgisi alınamadı`)
};

const cs_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyl přijat žádný identifikátor od Google`)
};

const bg_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не е получено удостоверение от Google`)
};

const ru_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не получены учётные данные от Google`)
};

const uk_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не отримано обліковних даних від Google`)
};

const ar_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم استلام بيانات اعتماد من Google`)
};

const hi_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई क्रेडेंशियल नहीं मिला`)
};

const th_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ได้รับข้อมูลรับรองจาก Google`)
};

const ja_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google から資格情報を受信しませんでした`)
};

const zh_cn2_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credential received from Google`)
};

const zh_hant1_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credential received from Google`)
};

const ko_forms_androidbeta_nocredential2 = /** @type {(inputs: Forms_Androidbeta_Nocredential2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credential received from Google`)
};

/**
* | output |
* | --- |
* | "No credential received from Google" |
*
* @param {Forms_Androidbeta_Nocredential2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_nocredential2 = /** @type {((inputs?: Forms_Androidbeta_Nocredential2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Nocredential2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_nocredential2(inputs)
	if (locale === "ms") return ms_forms_androidbeta_nocredential2(inputs)
	if (locale === "da") return da_forms_androidbeta_nocredential2(inputs)
	if (locale === "de") return de_forms_androidbeta_nocredential2(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_nocredential2(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_nocredential2(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_nocredential2(inputs)
	if (locale === "fil") return fil_forms_androidbeta_nocredential2(inputs)
	if (locale === "fr") return fr_forms_androidbeta_nocredential2(inputs)
	if (locale === "it") return it_forms_androidbeta_nocredential2(inputs)
	if (locale === "hu") return hu_forms_androidbeta_nocredential2(inputs)
	if (locale === "nl") return nl_forms_androidbeta_nocredential2(inputs)
	if (locale === "no") return no_forms_androidbeta_nocredential2(inputs)
	if (locale === "pl") return pl_forms_androidbeta_nocredential2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_nocredential2(inputs)
	if (locale === "pt") return pt_forms_androidbeta_nocredential2(inputs)
	if (locale === "ro") return ro_forms_androidbeta_nocredential2(inputs)
	if (locale === "fi") return fi_forms_androidbeta_nocredential2(inputs)
	if (locale === "sv") return sv_forms_androidbeta_nocredential2(inputs)
	if (locale === "vi") return vi_forms_androidbeta_nocredential2(inputs)
	if (locale === "tr") return tr_forms_androidbeta_nocredential2(inputs)
	if (locale === "cs") return cs_forms_androidbeta_nocredential2(inputs)
	if (locale === "bg") return bg_forms_androidbeta_nocredential2(inputs)
	if (locale === "ru") return ru_forms_androidbeta_nocredential2(inputs)
	if (locale === "uk") return uk_forms_androidbeta_nocredential2(inputs)
	if (locale === "ar") return ar_forms_androidbeta_nocredential2(inputs)
	if (locale === "hi") return hi_forms_androidbeta_nocredential2(inputs)
	if (locale === "th") return th_forms_androidbeta_nocredential2(inputs)
	if (locale === "ja") return ja_forms_androidbeta_nocredential2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_nocredential2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_nocredential2(inputs)
	return ko_forms_androidbeta_nocredential2(inputs)
});
export { forms_androidbeta_nocredential2 as "forms.androidBeta.noCredential" }